"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSpentAndInteractionsLoading = exports.TimeSpentAndInteractions = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BlocksTimeSpent_1 = require("./BlocksTimeSpent");
var Utils_1 = require("../Utils");
var Interactions_1 = require("./Interactions");
var commonStyles = __importStar(require("../CommonStyles.css"));
var styles = __importStar(require("./TimeSpentAndInteractions.css"));
var LOCALSTORAGE_BLOCKS_AND_INTERACTIONS_TAB = "page-analytics-blocks-and-interactions-tab";
var TimeSpentAndInteractions = function (_a) {
    var blockViewDurations = _a.blockViewDurations, noViewsYetComponent = _a.noViewsYetComponent, interactionsTableProps = _a.interactionsTableProps;
    var _b = __read((0, Utils_1.useLocalStorageNumber)(LOCALSTORAGE_BLOCKS_AND_INTERACTIONS_TAB, 0), 2), selectedTab = _b[0], setSelectedTab = _b[1];
    return (react_1.default.createElement("div", { className: "".concat(commonStyles.largeTabbedCard) },
        react_1.default.createElement(kaleidoscope_1.Tabs, { className: commonStyles.tabs, initialIndex: selectedTab, onChange: setSelectedTab },
            react_1.default.createElement(kaleidoscope_1.TabList, { className: commonStyles.tabList, "aria-label": "Time spent and Interactions selector", isBordered: true },
                react_1.default.createElement(kaleidoscope_1.Tab, null, "Time spent"),
                react_1.default.createElement(kaleidoscope_1.Tab, null, "Interactions")),
            react_1.default.createElement(kaleidoscope_1.TabPanels, { className: "".concat(commonStyles.tabPanels, " ").concat(styles.timeSpentAndInteractionsTabPanels) },
                react_1.default.createElement(kaleidoscope_1.TabPanel, null, noViewsYetComponent ? (renderNoViewsYet(noViewsYetComponent)) : (react_1.default.createElement(BlocksTimeSpent_1.BlocksTimeSpent, { blockViewDurations: blockViewDurations }))),
                react_1.default.createElement(kaleidoscope_1.TabPanel, null, noViewsYetComponent ? renderNoViewsYet(noViewsYetComponent) : react_1.default.createElement(Interactions_1.Interactions, __assign({}, interactionsTableProps)))))));
};
exports.TimeSpentAndInteractions = TimeSpentAndInteractions;
var TimeSpentAndInteractionsLoading = function () {
    return react_1.default.createElement(kaleidoscope_1.GhostBlock, { className: styles.timeSpentAndInteractionsGhostBlock });
};
exports.TimeSpentAndInteractionsLoading = TimeSpentAndInteractionsLoading;
function renderNoViewsYet(noViewsYetComponent) {
    return (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", align: "center", padding: "l" }, noViewsYetComponent));
}
